
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48583 6.48583 2 12 2C17.5142 2 22 6.48583 22 12C22 17.5142 17.5142 22 12 22C6.48583 22 2 17.5142 2 12ZM13.3737 5.13579C13.3084 5.08042 13.2316 5.0404 13.1488 5.01869C13.066 4.99698 12.9794 4.99414 12.8954 5.01038L6.4789 6.17701C6.3446 6.20144 6.22312 6.27221 6.13561 6.37698C6.0481 6.48175 6.00012 6.6139 6 6.75041V16.6667C5.99997 16.7947 6.04205 16.9192 6.11974 17.0209C6.19742 17.1226 6.30641 17.196 6.4299 17.2296L12.8464 18.9796C12.8964 18.993 12.948 18.9998 12.9998 19C13.1545 19 13.3028 18.9385 13.4122 18.8292C13.5216 18.7198 13.5831 18.5714 13.5831 18.4167V5.58378C13.5831 5.49832 13.5644 5.41391 13.5282 5.3365C13.492 5.25908 13.4393 5.19057 13.3737 5.13579ZM11.8331 13.7502C11.8331 13.9049 11.7717 14.0532 11.6623 14.1626C11.5529 14.272 11.4045 14.3335 11.2498 14.3335C11.0951 14.3335 10.9468 14.272 10.8374 14.1626C10.728 14.0532 10.6665 13.9049 10.6665 13.7502V12.5835C10.6665 12.4288 10.728 12.2805 10.8374 12.1711C10.9468 12.0617 11.0951 12.0002 11.2498 12.0002C11.4045 12.0002 11.5529 12.0617 11.6623 12.1711C11.7717 12.2805 11.8331 12.4288 11.8331 12.5835V13.7502ZM17.083 17.2501H14.7497V16.0835H16.4997V7.91706H14.7497V6.75043H17.083C17.2377 6.75043 17.386 6.81188 17.4954 6.92128C17.6048 7.03067 17.6663 7.17904 17.6663 7.33374V16.6668C17.6663 16.8215 17.6048 16.9698 17.4954 17.0792C17.386 17.1886 17.2377 17.2501 17.083 17.2501Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowSingleSignOutFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
